/**
 * The catalogue tree as a filter that another feature's screen can show.
 *
 * The stock pages are the referential's, and a feature never imports another: the
 * application hands them this component, which reads the tree and the level names on its
 * own and reports the chosen path. The same picker as the consultation's, so « Carrosserie
 * & Mécanique » reads and behaves the same on both screens.
 */

import { useCallback, useMemo } from "react";
import type { ApiClient } from "@hardauto/core-api";
import { useResource } from "@hardauto/core-data";

import { CatalogApi } from "../../api";
import { CategoryPicker } from "./CategoryPicker";
import "../catalog.css";

export interface CatalogCategoryFilterProps {
  client: ApiClient;
  /** The chosen category's path; empty for the whole catalogue. */
  selected: string;
  onSelect: (path: string) => void;
}

export function CatalogCategoryFilter({ client, selected, onSelect }: CatalogCategoryFilterProps) {
  const api = useMemo(() => new CatalogApi(client), [client]);
  const fetcher = useCallback(async () => {
    const [tree, levels] = await Promise.all([api.categoryTree(false), api.levels()]);
    return { roots: tree.roots, levels: levels.items };
  }, [api]);
  const tree = useResource(fetcher);

  return (
    <CategoryPicker
      roots={tree.data?.roots ?? []}
      levels={tree.data?.levels ?? []}
      selected={selected}
      onSelect={onSelect}
    />
  );
}
